<template>
  <div class="liu" v-wechat-title="'人工审核'">
    <!-- 提示信息 -->
    <div class="tips page-padding-l-r">
      <span class="txt">身份认证照片</span>
    </div>
    <!-- 身份证照片信息 -->
    <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
      <!-- Label-->
      <div style="width: 95px;">
        <span>证件照</span>
      </div>
      <!-- 头像页 -->
      <div class="align-center title-5 say-color" style="margin-right: 0.5rem;">
        <div class="id-card-style" @click="cameraImgClick('renXiang')">
          <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-headshot" />
        </div>
        <div class="id-card-tips">头像页</div>
      </div>
      <!-- 国徽页 -->
      <div class="align-center title-5 say-color">
        <div class="id-card-style" @click="cameraImgClick('guoHui')">
          <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-emblem" />
        </div>
        <div class="id-card-tips">国徽页</div>
      </div>
    </div>
    <!-- 手持身份证信息 -->
    <div class="flex-s page-padding-l-r padding-t-10 padding-b-10 margin-t-10 color-f-bg">
      <div style="width: 95px;">
        <div>手持身份</div>
        <div>证正面照</div>
      </div>
      <div class="handFaceStyle" @click="cameraImgClick('shouChi')">
        <img class="img" :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" />
      </div>
    </div>
    <!-- 手持身份证信息提示 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      避免证件与头部重叠，身份证正反面内容要清晰可见，完全露出双手手臂；上传高分辨率图片可能需要一些时间请耐心等待
    </div>
    <!-- 提交按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" :disabled="!renXiang.webUrl || !guoHui.webUrl || !shouChi.webUrl"
        @click="onSubmitBtnClick">提交</mt-button>
    </div>
  </div>
</template>

<script>
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import { SubmitAuditAndUserImage } from '@/api/weChat';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'ManualReview',
  components: { SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证姓名
      idCardName: '',
      // 银行卡状态
      bankCardStatus: 0,
      // 身份证认证批次号
      idCardBatchNo: '',
      // 信用卡人工审核标识
      auditGuid: '',
      // 人脸\信用卡标识
      faceCreditIndex: -1,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.idCardName = this.$route.query.idcardname;
      this.bankCardStatus = parseInt(this.$route.query.bankcardstatus);
      this.idCardBatchNo = this.$route.query.idcardbatchno || '';
      this.auditGuid = this.$route.query.auditguid || '';
      this.faceCreditIndex = parseInt(this.$route.query.facecreditindex || 999);
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scweburl).replace('|', '?');
      };
    });
  },
  methods: {
    cameraImgClick(imgTypeStr) {
      const data = {
        page: 'media',
        h5Page: 'ManualReview',
        imgType: imgTypeStr,
        idCardName: this.idCardName,
        bankCardStatus: this.bankCardStatus,
        idCardBatchNo: this.idCardBatchNo,
        auditGuid: this.auditGuid,
        faceCreditIndex: this.faceCreditIndex,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
        scWebUrl: encodeURIComponent(this.shouChi.webUrl.replace('?', '|'))
      }
      wx.miniProgram.postMessage({ data });
      wx.miniProgram.redirectTo({
        url: '/pages/media/media',
      });
    },
    // 提交数据
    onSubmitBtnClick() {
      CusLoadingOpen();
      const data = {};
      if (this.faceCreditIndex === 1) {  // 人脸信息
        data.idCardFrontUrl = this.renXiang.webUrl;
        data.idCardBackUrl = this.guoHui.webUrl;
        data.holdIdCardUrl = this.shouChi.webUrl;
        data.batchNo = this.idCardBatchNo;
      } else if (this.faceCreditIndex === 2) { // 信用卡
        data.idCardFrontUrl = this.renXiang.webUrl;
        data.idCardBackUrl = this.guoHui.webUrl;
        data.holdIdCardUrl = this.shouChi.webUrl;
        data.auditGuid = this.auditGuid;
      } else { // 其它情况
        data.idCardFrontUrl = this.renXiang.webUrl;
        data.idCardBackUrl = this.guoHui.webUrl;
        data.holdIdCardUrl = this.shouChi.webUrl;
      }
      SubmitAuditAndUserImage(data)
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            CusAlert('申请成功', () => {
              // 不需要手持，则跳转回小程序的结算卡添加页面
              // 1.向小程序发消息，更新状态
              wx.miniProgram.postMessage({ data: { page: "refresh" } });
              // 2.跳转小程序添加储蓄卡的页面
              // 2024.11.1 添加判断用户储蓄卡状态，0才进添卡页面，其它状态直接返回首页
              if (this.bankCardStatus === 0) {
                wx.miniProgram.redirectTo({
                  url: `/pages/bankCard/savingsCard/savingsCard?idCardName=${this.idCardName}&flowName=认证流程`,
                });
              } else {
                wx.miniProgram.navigateBack();
              }
            });
          } else {
            CusAlert(res.msg);
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.tips {
  line-height: 1;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  .txt {
    font-size: $title5;
    color: $explain-color;
  }
}

.id-card-style {
  width: 6rem;
  height: 4rem;
  vertical-align: middle;
  overflow: hidden;
  @include dynamic-color;

  .img {
    width: 100%;
    height: 100%;
  }
}

.id-card-tips {
  line-height: 1;
  padding-top: 0.2rem;
}
</style>
